import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Eye, LogIn, UserPlus } from 'lucide-react';
import { ANALYTICS_EVENTS, trackEvent } from '../utils/analytics';

const MobileWelcome: React.FC = () => {
  const navigate = useNavigate();

  const handleCreateAccount = () => {
    trackEvent(ANALYTICS_EVENTS.MOBILE_WELCOME_CREATE_ACCOUNT_CLICKED);
    navigate('/auth?mode=signup');
  };

  const handleLogIn = () => {
    trackEvent(ANALYTICS_EVENTS.MOBILE_WELCOME_LOGIN_CLICKED);
    navigate('/auth?mode=login');
  };

  const handleExploreFirst = () => {
    try {
      sessionStorage.setItem('ballotr_mobile_explore_session', 'true');
    } catch {
      // Ignore storage failures.
    }
  
    trackEvent(ANALYTICS_EVENTS.MOBILE_WELCOME_EXPLORE_FIRST_CLICKED, {
      remembered: false,
      scope: 'session',
    });
  
    navigate('/');
  };

  return (
    <main className="h-screen overflow-hidden bg-[#034C8C] text-white">
      <div className="relative flex h-full flex-col items-center justify-center px-6 py-4">
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_top,#0A66B2_0%,#034C8C_45%,#012C55_100%)]" />

                <img
                src="/assets/images/mobile-welcome-capitol.svg"
                alt=""
                aria-hidden="true"
                className="pointer-events-none absolute right-[-95px] top-[20%] h-[50%] w-auto opacity-45"
                />


        <div className="absolute bottom-0 left-0 right-0 h-28 bg-gradient-to-t from-black/25 to-transparent" />
        <div className="absolute bottom-0 left-0 flex h-20 w-full items-end justify-around opacity-25">
          <div className="h-12 w-8 rounded-t-full bg-black/40" />
          <div className="h-16 w-20 rounded-sm bg-black/40" />
          <div className="h-14 w-16 rounded-sm bg-black/40" />
          <div className="h-10 w-8 rounded-t-full bg-black/40" />
          <div className="h-16 w-20 rounded-sm bg-black/40" />
        </div>

        <div className="relative z-10 flex h-full w-full max-w-sm flex-col items-center justify-center text-center">
          <div className="flex flex-col items-center">
            <img
              src="/assets/images/splash_icon1.png"
              alt="Ballotr"
              className="h-40 w-40 object-contain drop-shadow-xl"
              draggable={false}
            />

            <div className="mt-1 text-6xl font-extrabold tracking-tight text-white drop-shadow-sm">
              ballotr
            </div>
          </div>

          <h1 className="mt-4 text-2xl font-extrabold leading-tight text-white">
            Political news,
            <br />
            turned into action.
          </h1>

          <div className="mt-4 h-1 w-14 rounded-full bg-[#FF2D3D]" />

          <p className="mt-5 text-sm leading-6 text-white/85">
            Follow public issues, take a side, and connect your stance to real civic action.
          </p>

          <div className="mt-8 w-full space-y-3">
            <button
              type="button"
              onClick={handleCreateAccount}
              className="flex w-full items-center justify-center gap-3 rounded-2xl bg-white px-5 py-3.5 text-base font-bold text-[#034C8C] shadow-xl transition active:scale-[0.99]"
            >
              <UserPlus className="h-6 w-6" />
              Create Account
            </button>

            <button
              type="button"
              onClick={handleLogIn}
              className="flex w-full items-center justify-center gap-3 rounded-2xl border-2 border-white bg-white/5 px-5 py-3.5 text-base font-bold text-white shadow-lg backdrop-blur transition active:scale-[0.99]"
            >
              <LogIn className="h-6 w-6" />
              Log In
            </button>
          </div>

          <button
            type="button"
            onClick={handleExploreFirst}
            className="mt-6 flex items-center justify-center gap-2 text-base font-bold text-[#55C7FF] transition hover:text-white"
          >
            <Eye className="h-5 w-5" />
            Explore First
          </button>

          <p className="mt-2 max-w-xs text-xs leading-5 text-white/75">
            You can browse campaigns before creating an account.
            <span className="mt-1 block text-white/65">
              Ballotr is independent and does not represent any government entity.
            </span>
          </p>
        </div>
      </div>
    </main>
  );
};

export default MobileWelcome;